// Best-effort, keyword-based classification of a provision_error string —
// NOT a guaranteed classification. Extend these two lists as new error
// strings are observed in the wild.
const CAPACITY_KEYWORDS = [
  "insufficient", "quota", "capacity", "limitexceeded",
  "sold out", "no stock", "resourceinsufficient", "resourceunavailable",
  "provider-side",
];
const NETWORK_KEYWORDS = [
  "timeout", "ssh", "connection refused", "connect", "unreachable",
];

export function classifyProvisionError(error) {
  if (!error) return null;
  const e = error.toLowerCase();
  if (CAPACITY_KEYWORDS.some(k => e.includes(k))) {
    return { label: "Provider issue — may need manual terminate + recreate", tone: "capacity" };
  }
  if (NETWORK_KEYWORDS.some(k => e.includes(k))) {
    return { label: "Install/network issue — retry recommended", tone: "network" };
  }
  return { label: "Install failed", tone: "generic" };
}
